import { createRouter, createWebHistory } from "vue-router";
import Default from "../views/dashboards/Default.vue";
import DataTables from "../views/applications/DataTables.vue";
import LoginPage from "../views/auth/LoginPage.vue";
import UserManage from "../views/users/UserManage.vue";
import RoleManage from "../views/roles/RoleManage.vue";
import WebsiteManage from "../views/websites/WebsiteManage.vue";
import Forbidden from "../views/auth/Forbidden.vue";

// 以下为框架原有页面，暂不使用
// import Landing from "../views/dashboards/Landing.vue";
// import Automotive from "../views/dashboards/Automotive.vue";
// ...

const routes = [
  { path: "/", name: "/", redirect: "/dashboards/dashboard-default" },
  { path: "/login", name: "Login", component: LoginPage, meta: { public: true } },
  { path: "/dashboards/dashboard-default", name: "仪表盘", component: Default, meta: { permission: "dashboard:view" } },
  { path: "/applications/data-tables", name: "数据报表", component: DataTables, meta: { permission: "report:view" } },
  { path: "/users/manage", name: "用户管理", component: UserManage, meta: { permission: "user:manage" } },
  { path: "/roles/manage", name: "角色管理", component: RoleManage, meta: { permission: "role:manage" } },
  { path: "/websites/manage", name: "网站管理", component: WebsiteManage, meta: { permission: "website:manage" } },
  { path: "/403", name: "Forbidden", component: Forbidden, meta: { public: true } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next();

  const token = localStorage.getItem("token");
  if (!token) return next("/login");

  const requiredPerm = to.meta.permission;
  if (requiredPerm) {
    const perms = JSON.parse(localStorage.getItem("perms") || "[]");
    if (!perms.includes(requiredPerm)) {
      return next("/403");
    }
  }

  next();
});

export default router;
